import React from "react";
import { AgGridReact } from "ag-grid-react";
import { ColDef, themeMaterial, CellStyle } from "ag-grid-community";
import makeStyles from "@mui/styles/makeStyles";

interface MinimalAgTableProps {
  rowData: any[];
  columnDefs: ColDef[];
}

const cellStyle: CellStyle = {
  padding: "2px 4px",
  lineHeight: "1.2",
};

const useStyles = makeStyles({
  tableWrapper: {
    // Normally 150px - set lower for single line tables
    "& .ag-center-cols-viewport": {
      minHeight: "40px !important",
    },
  },
});

export const MinimalAgTable: React.FC<MinimalAgTableProps> = ({ rowData, columnDefs }) => {
  const classes = useStyles();

  return (
    <div className={classes.tableWrapper}>
      <AgGridReact
        theme={themeMaterial}
        rowData={rowData}
        columnDefs={columnDefs}
        defaultColDef={{
          cellStyle: cellStyle,
          headerStyle: cellStyle,
          resizable: false,
          suppressMovable: true,
          flex: 1,
          wrapText: true,
          autoHeight: true,
          sortable: false,
        }}
        headerHeight={32}
        domLayout="autoHeight"
        suppressDragLeaveHidesColumns={true}
        suppressColumnMoveAnimation={true}
      />
    </div>
  );
};
